import { z } from 'zod';
import { reauthSchema } from './data-lifecycle.js';
import { tenantSlugSchema } from './slug.js';
import { PASSWORD_MAX, PASSWORD_MIN } from './tenant.js';
export const USER_ROLES = [
    'system_admin',
    'standard',
    'limited',
    'fully_limited',
    'crm_lite',
];
const passwordSchema = z
    .string()
    .min(PASSWORD_MIN, `Parola en az ${PASSWORD_MIN} karakter olmalı`)
    .max(PASSWORD_MAX)
    .refine((p) => p.trim() === p, 'Parola boşlukla başlayıp bitemez');
export const loginInputSchema = z.object({
    tenantSlug: tenantSlugSchema,
    email: z.string().trim().toLowerCase().check(z.email()).max(254),
    password: z.string().min(1).max(PASSWORD_MAX),
});
export const totpLoginInputSchema = z.object({
    challengeToken: z.string().min(20).max(2048),
    code: z.string().regex(/^\d{6}$/, '6 haneli kod'),
});
export const recoveryLoginInputSchema = z.object({
    challengeToken: z.string().min(20).max(2048),
    // M6 WP 6.2: güncel biçim 80 bit (`xxxxx-xxxxx-xxxxx-xxxxx`, 23 karakter); eski 40 bit kodlar da kabul edilir
    recoveryCode: z.string().min(8).max(40),
});
export const sessionUserSchema = z.object({
    id: z.guid(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    role: z.enum(USER_ROLES),
    isOwner: z.boolean(),
    totpEnabled: z.boolean(),
});
export const meResponseSchema = z.object({
    user: sessionUserSchema,
    tenant: z.object({
        id: z.guid(),
        slug: tenantSlugSchema,
        name: z.string(),
        /** M3 K-M3-01: demo çalışma alanı (kalıcı "Demo" şeridi; dış etki yok) */
        isDemo: z.boolean().default(false),
    }),
    session: z.object({ id: z.guid(), expiresAt: z.string() }),
    capabilities: z.array(z.string()),
});
export const loginResponseSchema = z.union([
    z.object({ status: z.literal('ok'), me: meResponseSchema }),
    z.object({ status: z.literal('totp_required'), challengeToken: z.string() }),
]);
export const sessionListItemSchema = z.object({
    id: z.guid(),
    current: z.boolean(),
    userAgent: z.string(),
    createdAt: z.string(),
    lastUsedAt: z.string().nullable(),
    expiresAt: z.string(),
});
export const inviteInputSchema = z.object({
    email: z.string().trim().toLowerCase().check(z.email()).max(254),
    firstName: z.string().trim().min(1).max(80),
    lastName: z.string().trim().min(1).max(80),
    role: z.enum(USER_ROLES).default('standard'),
    /**
     * K1: YÖNETİCİ daveti (rol çalışma alanı ayarlarını ya da kullanıcı yönetimini taşıyorsa — `inviteNeedsReauth`) çalışma alanı
     * sahibinin mevcut yeniden kimlik doğrulamasını ister: parola + açıksa iki adımlı doğrulama kodu (`reauthSchema`). Diğer
     * rollerde yok sayılır ve saklanmaz.
     */
    reauth: reauthSchema.optional(),
});
/** `POST /auth/invite/resend` (M7 T2): henüz kabul edilmemiş davetin yeniden gönderilmesi — yalnız hedef kullanıcı kimliği */
export const inviteResendInputSchema = z
    .object({
    userId: z.guid(),
    /** K1: iptal edilmiş YÖNETİCİ davetini yeniden açmak sahibin yeniden kimlik doğrulamasını ister (davetle aynı) */
    reauth: reauthSchema.optional(),
})
    .strict();
/** v3.1 A3 (K-M7-44.9): bekleyen daveti iptal et — bağlantı geçersiz olur, kullanıcı "Ayrıldı" (davet iptal) durumuna geçer */
export const inviteCancelInputSchema = z.object({ userId: z.guid() }).strict();
export const acceptInviteInputSchema = z.object({
    token: z.string().min(20).max(200),
    password: passwordSchema,
});
export const forgotPasswordInputSchema = z.object({
    tenantSlug: tenantSlugSchema,
    email: z.string().trim().toLowerCase().check(z.email()).max(254),
});
export const resetPasswordInputSchema = z.object({
    token: z.string().min(20).max(200),
    password: passwordSchema,
});
export const totpConfirmInputSchema = z.object({ code: z.string().regex(/^\d{6}$/) });
export const totpDisableInputSchema = z.object({
    password: z.string().min(1).max(PASSWORD_MAX),
    code: z.string().regex(/^\d{6}$/),
});
export const totpSetupResponseSchema = z.object({
    secret: z.string(),
    otpauthUrl: z.string(),
});
export const totpConfirmResponseSchema = z.object({
    enabled: z.literal(true),
    recoveryCodes: z.array(z.string()).length(10),
});
//# sourceMappingURL=auth.js.map